<div class="d-flex justify-content-end align-items-center p-2">
    <i (click)="closeModal()" class="bi bi-x fs-2 cursor-pointer"></i>
</div>

<div class="container">
    <aerp-base-schema-form *ngIf="model && layout" [model]="model" [layout]="layout" (onSubmit)="onSubmit($event)">
    </aerp-base-schema-form>
</div>